import { render } from "./EsqueciSenha.vue?vue&type=template&id=533947de&scoped=true"
import script from "./EsqueciSenha.vue?vue&type=script&lang=js"
export * from "./EsqueciSenha.vue?vue&type=script&lang=js"

import "./EsqueciSenha.vue?vue&type=style&index=0&id=533947de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533947de"]])

export default __exports__